module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-idea-page"
  }, [_c('header-bar', {
    attrs: {
      "process": "signup"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "big-idea"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "image-circle"
  }, [(this.$root.profilereg.profileimg === 'default') ? _c('img', {
    attrs: {
      "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
    }
  }) : _c('img', {
    attrs: {
      "src": this.$root.profilereg.profileimg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h4', [_vm._v(_vm._s(this.$root.profilereg.firstname + ' ' + this.$root.profilereg.surname))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(this.$root.profilereg.jobtitle))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(this.$root.profilereg.location))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('label', [_vm._v("(Optional) Do you have a big idea for Africa " + _vm._s(this.$root.profilereg.firstname) + "?")]), _vm._v(" "), _c('a', {
    staticClass: "link-simple",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addExample($event)
      }
    }
  }, [_vm._v("View Example")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.bigIdea),
      expression: "bigIdea",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "id": "bigIdea",
      "rows": "4",
      "placeholder": "My big idea for africa is..."
    },
    domProps: {
      "value": (_vm.bigIdea)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bigIdea = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }, [_vm._v(_vm._s(this.bigIdea))])])])])]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stepBack($event)
      }
    }
  }, [_vm._v("Change your skills")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.progress($event)
      }
    }
  }, [_vm._v("Next")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-243bc63d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/Register-Step-8.vue
// module id = 692
// module chunks = 1